<template>
  <div>
    <slot/>
  </div>
</template>

<script setup>
import Highcharts from "@/highcharts"
import { onMounted } from "vue"

const props = defineProps({
  year1: Number,
  year2: Number,
  data: Array,
  colors: Array,
  inflation: Number,
})

onMounted(() => {
  $("#col_table").dataTable({
    bPaginate: false,
    bInfo: false,
    order: [[2, "asc"], [1, "asc"]],
    aoColumnDefs: [
      { sType: "html", aTargets: [0] },
      { asSorting: ["asc", "desc"], aTargets: [0, 1, 2] },
      { asSorting: ["desc", "asc"], aTargets: ["_all"] },
      { type: "currency", targets: [3, 5] },
    ],
    oLanguage: {
      sSearch: "Filter schools:",
    },
  })

  const { year1, colors, year2, data, inflation } = props

  new Highcharts.chart("col_chart", {
    chart: {
      type: "column",
    },
    colors,
    title: { text: "Cost of Living Budget Change" },
    subtitle: {
      text: `${year1}-${year1 + 1} to ${year2}-${year2 + 1}`,
    },
    xAxis: { labels: { enabled: false } },
    yAxis: {
      labels: { formatter() {
        return `${this.value}%`
      } },
      plotLines: [{ color: "#007bff", dashStyle: "longdashdot", value: inflation, width: 2, label: {
        text: `Inflation between ${year1} and ${year2}, ${inflation}%`,
        align: "left",
        x: 1, y: -10,
      } }],
      min: -75,
      max: 100,
      title: { text: "% Change" },
    },
    legend: { enabled: false },
    tooltip: {
      pointFormat: "COL Change: <b>{point.y}%</b>",
    },
    series: [{
      name: "Population",
      data,
      dataLabels: { enabled: false },
    }], plotOptions: { column: { colorByPoint: true } },
  })
})
</script>
